<div class="body">

    <div class="headline">
        Fehler
    </div>

    <div class="desc">
        {{message}}
    </div>

    <div class="footer">

        <button (click)="goBack()" mat-raised-button>
            Zurück
        </button>

        <button color="primary" (click)="navigateToMainpage()" mat-raised-button>
            Zur Startseite
        </button>

    </div>

</div>